// extracted by mini-css-extract-plugin
export default {"brand-picker":"BrandKit_brand-picker__QJzzp","upload-icon":"BrandKit_upload-icon__lMyye"};